// Ameren Client Config
import { isProd } from "../env";
import template from "./_template";

const ameren_config = {
  name: "ameren",
  disabled_features: {
    ...template.disabled_features,
    user_management: true, // DISABLE user management as using SSO exclusively
  },
  enabled_features: {
    ...template.enabled_features,
    sso_microsoft_saml: true,
    campaign_templates: true, // AMRN-909 Ad Hoc Templates
    customer_preference_dip: true, // Whether to enable campaigns to check a customer preference table before loading a dataset
    dataset_import: true, // Whether to ENABLE the presence of the "Data Summary" and "Create Dataset" Pages
    division_selection: [
      // Whether to ENABLE the presence of the "Division" selection in the create campaign flow
      { label: "Missouri", value: "MO" },
      { label: "Illinois", value: "IL" },
      { label: "Both", value: "BOTH" },
    ],
    campaign_tag: true,
  },
  custom_labels: {
    custom4_vch: "Dip: Fallback Device Type",
    custom5_vch: "Dip: Fallback Device",
  },
  sms: {
    short_codes: [
      // Short Codes are ENV dependent for Ameren, managed below
    ],
  },
  voice: {
    caller_id_options: [
      { label: "Select a phone number", isDisabled: true },
      { label: "(800) 755-5000 (Illinois)", value: "8007555000" },
      { label: "(800) 552-7583 (Missouri)", value: "8005527583" },
    ],
  },
};

if (isProd()) {
  ameren_config.sms.short_codes.push({ label: "263736", value: "263736" }); // REST
} else {
  ameren_config.sms.short_codes.push({ label: "22986", value: "22986" }); // REST
}

export default ameren_config;
